import type { Photo } from './AevocamViewer'

export type OutlierMark = {
  index: number
  frac: number
}

/** One timeline mark per outlier photo. */
export function buildOutlierMarks(
  photos: (Photo | undefined)[],
  totalPhotos: number,
): OutlierMark[] {
  if (totalPhotos < 1) return []

  const cap = Math.max(totalPhotos - 1, 0)
  const denom = Math.max(cap, 1)
  const toFrac = (index: number) => Math.min(Math.max(index, 0), cap) / denom

  const marks: OutlierMark[] = []
  for (let i = 0; i < photos.length; i++) {
    if (photos[i]?.outlier) {
      marks.push({ index: i, frac: toFrac(i) })
    }
  }
  return marks
}
